:host {
  display: block;
  height: 100%;
  left: 0;
  overflow: hidden;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: $z-index-spinner-overlay;
}



:host([status='opening']) {
  opacity: 0;
}

:host([status='opened']) {
  opacity: 1;
  transition: opacity $animationSpeed-fast ease-out;
}

:host([status='closing']) {
  opacity: 0;
  transition: opacity $animationSpeed-fast ease-out;
}

:host([status='closed']) {
  opacity: 0;
  display: none;
}


.container {
  display: block;
  background-color: white;
  text-align: center;
  width: 90%;
  padding: 30px;

  @media (width >=768px) {
    padding: 50px;
    width: 83.3333%;
  }

  @media (width >=1024px) {
    max-width: 960px;
    width: 66.6666%;
    padding: 50px;
  }

  ux-loader {
    left: 0;
    transform: inherit;
  }
}

.backdrop {
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgb(0 0 0 / 30%);
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}

.headline {
  margin-top: 0;
  margin-bottom: 20px;

  &:empty {
    display: none;
  }
}

.subline {
  color: $color-gray-text;
  margin-top: 25px;
  margin-bottom: 0;

  &:empty {
    display: none;
  }
}

.loader {
  display: block;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
}

h2 {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
}

p {
  font-family: Frutiger-Light, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-rendering: optimizelegibility;
  font-weight: 400;
  font-size: var(--ux-text-font-size-normal);
  line-height: var(--ux-text-line-height-normal);
}
